import { Alert, Button, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MfaCodePanel = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  color: theme.customColors.textPrimary,
  gap: theme.spacing(4),
  maxWidth: theme.spacing(56),
  width: "100%",

  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(3)
  }
}));

export const MfaCodeTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(28),
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1.2,
  textAlign: "center",

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.pxToRem(20)
  }
}));

export const MfaCodeDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  lineHeight: 1.2,
  overflowWrap: "anywhere",
  textAlign: "center",
  width: "100%",

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.pxToRem(14)
  }
}));

export const MfaCodeDigits = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(2),
  justifyContent: "center",
  maxWidth: "100%",

  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(1)
  }
}));

export const MfaCodeDigit = styled("input")(({ theme }) => ({
  "&:focus": {
    borderColor: theme.customColors.borderPrimaryCta,
    outline: "none"
  },
  "&[aria-invalid='true']": {
    borderColor: theme.customColors.borderError
  },
  backgroundColor: theme.customColors.backgroundPrimary,
  border: `1px solid ${theme.customColors.border}`,
  borderRadius: theme.shape.borderRadius * 2,
  boxSizing: "border-box",
  color: theme.customColors.textPrimary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(16),
  fontWeight: theme.typography.fontWeightBold,
  height: theme.spacing(5.5),
  minWidth: 0,
  padding: 0,
  textAlign: "center",
  width: theme.spacing(5.5),

  [theme.breakpoints.down("sm")]: {
    height: theme.spacing(5),
    width: theme.spacing(5)
  }
}));

export const MfaCodeError = styled(Alert)(({ theme }) => ({
  "& .MuiAlert-icon": {
    color: theme.customColors.borderError,
    marginRight: theme.spacing(1.5),
    padding: 0
  },
  "& .MuiAlert-message": {
    padding: 0
  },
  alignItems: "center",
  backgroundColor: theme.customColors.backgroundError,
  border: `1px solid ${theme.customColors.borderError}`,
  borderRadius: theme.shape.borderRadius,
  color: theme.customColors.textPrimaryAlternative,
  fontSize: theme.typography.pxToRem(16),
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: 1.5,
  maxWidth: "100%",
  padding: theme.spacing(1.25, 2)
}));

export const MfaCodeLink = styled(Button)(({ theme }) => ({
  "&.Mui-focusVisible": {
    outline: `2px solid ${theme.customColors.borderAccent}`,
    outlineOffset: theme.spacing(0.5)
  },
  "&:hover": {
    backgroundColor: "transparent",
    color: theme.customColors.backgroundPrimaryCtaHover
  },
  alignSelf: "center",
  color: theme.customColors.backgroundPrimaryCta,
  fontSize: theme.typography.pxToRem(12),
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1.5,
  minWidth: 0,
  padding: 0,
  textTransform: "none"
}));
